import { ReactElement, ReactNode } from 'react';
import { Box, Paper } from '@mui/material';
import FormPageTitle, { FormPageTitleVariant } from './FormPageTitle';
import { getShowPageContentInnerSx, showPagePaperSx } from '../../pageLayoutSx';

export interface DefaultFormPageLayoutProps {
  title?: string;
  titleVariant?: FormPageTitleVariant;
  entityHeader?: ReactElement;
  breadcrumbs?: ReactElement;
  buttons: ReactElement;
  titleActions?: ReactNode;
  children: ReactElement | ReactElement[];
  hasSeparateSections?: boolean;
}

const DefaultFormPageLayout = ({
  children,
  title,
  titleVariant,
  breadcrumbs,
  entityHeader,
  buttons,
  titleActions,
  hasSeparateSections,
}: DefaultFormPageLayoutProps) => {
  return (
    <Paper sx={showPagePaperSx}>
      {breadcrumbs ? <Box mb={entityHeader ? 3.5 : 2.5}>{breadcrumbs}</Box> : null}
      {entityHeader ? <Box mb={4.25}>{entityHeader}</Box> : null}
      <Box sx={{ display: { xs: 'block', sm: 'flex' } }}>
        <Box className="show-page__content-inner" sx={getShowPageContentInnerSx(hasSeparateSections)}>
          <FormPageTitle
            title={title}
            titleActions={titleActions}
            variant={titleVariant || 'h2'}
            color={titleVariant === 'h4' ? 'primary' : 'brand'}
            containerSx={{ mb: title || titleActions ? 3 : 0 }}
          />
          {children}
          {buttons}
        </Box>
      </Box>
    </Paper>
  );
};

export default DefaultFormPageLayout;
